import {
  getReportDetailOutputUrl,
  getReportSummaryOutputUrl,
  getValidationDetailReportOutputUrl,
  getValidationHistorySummary,
  getValidationSummaryReportOutputUrl,
} from "./constants";
import { IgetReportsByRunInstanceProps } from "../types/reports";
import base from "../middlewares/interceptors";

export const getReportsSummaryByRunInstance = async ({
  runName,
  page,
  pSize,
  runDate,
  formattedDate,
}: IgetReportsByRunInstanceProps) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;
    const response = await base.get(
      `${getReportSummaryOutputUrl}/${runName}/${formattedDate}?page=${pageN}&size=${pageS}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getReportsDetailsByRunInstance = async ({
  runName,
  page,
  pSize,
  runDate,
  formattedDate,
}: IgetReportsByRunInstanceProps) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;
    const response = await base.get(
      `${getReportDetailOutputUrl}/${runName}/${formattedDate}?page=${pageN}&size=${pageS}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getValidationReportsByRunInstanceAndRunDate = async ({
  runName,
  runDate,
  page,
  pSize,
  formattedDate,
}: IgetReportsByRunInstanceProps) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;
    const response = await base.get(
      `${getValidationDetailReportOutputUrl}/${runName}/${formattedDate}?page=${pageN}&size=${pageS}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
export const getValidationSummaryReportsByRunInstanceAndRunDate = async ({
  runName,
  runDate,
  page,
  pSize,
  formattedDate,
}: IgetReportsByRunInstanceProps) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;
    const response = await base.get(
      `${getValidationSummaryReportOutputUrl}/${runName}/${formattedDate}?page=${pageN}&size=${pageS}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export interface IExecutionHistoryData {
  page: number;
  pSize: number;
  domainId?: number | null;
  resourceId?: number | null;
  fromDate?: string | undefined;
  searchFilterData?: any;
}

// Fields to request from the summary endpoint for the listing page
const VALIDATION_HISTORY_LISTING_FIELDS = [
  "id",
  "domain_name",
  "domain_id",
  "system_id",
  "resource_id",
  "resource_name",
  "execution_name",
  "run_id",
  "run_name",
  "execution_sub_group_id",
  "execution_sub_group_code",
  "execution_time",
  "job_status",
  "execution_mode",
  "IncidentStatus",
  "output_logs",
  "score",
  "score_calculated_on",
].join(",");

export const getValidationHistory = async ({
  page,
  pSize,
  domainId,
  resourceId,
  fromDate,
  searchFilterData,
}: IExecutionHistoryData) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;
    // Combine individual parameters with searchFilterData
    const allFilterData = {
      ...searchFilterData,
      ...(domainId && { domain_id: domainId }),
      ...(resourceId && { resource_id: resourceId }),
      ...(fromDate && { date: fromDate }),
    };
    const params = new URLSearchParams({
      page: pageN,
      size: pageS,
      fields: VALIDATION_HISTORY_LISTING_FIELDS,
      ...Object.entries(allFilterData || {}).reduce(
        (acc: any, [key, value]: any) => {
          if (value !== null && value !== undefined && value !== "") {
            // Transform start_date to date for URL parameters
            const paramKey = key === "start_date" ? "date" : key;
            acc[paramKey] = value;
          }
          return acc;
        },
        {},
      ),
    });
    const response = await base.get(
      `${getValidationHistorySummary}?${params.toString()}`,
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};
